module.exports = __webpack_public_path__ + "media/placeholders/avatar-f9e548d5.png";